// Generated by scripts/write-deployment.js — do not edit
export const UNICAT_COLOR = '#ff834a'
export const TITLE_PREFIX = ''
